/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * NACC - Required vehicle and size selections
 * Warehouse 7.0.1 customization
 *
 * Preserve customer selections after Warehouse
 * re-renders the product variant picker.
 */
(function () {
  'use strict';

  // Remember selections separately for each product form.
  const selections = new Map();

  function getRequiredSelects(picker) {
    return Array.from(
      picker.querySelectorAll(
        'select[data-required-selection="true"]'
      )
    );
  }

  function getKey(picker) {
    return picker.getAttribute('form-id');
  }

  function rememberSelection(select) {
    const picker = select.closest('variant-picker');
    if (!picker) return;

    const key = getKey(picker);
    if (!key) return;

    const position = select.dataset.optionPosition;
    const current = selections.get(key) || {};

    current[position] = select.value;
    selections.set(key, current);
  }

  function restoreSelections(picker) {
    const key = getKey(picker);
    const saved = selections.get(key);

    if (!saved) return;

    getRequiredSelects(picker).forEach(function (select) {
      const position = select.dataset.optionPosition;
      const value = saved[position];

      if (!value) return;

      const matchingOption = Array.from(
        select.options
      ).find(function (option) {
        return option.value === value &&
          !option.disabled;
      });

      if (!matchingOption) return;

      // Restore the displayed selection without
      // triggering another Warehouse variant change.
      select.value = value;

      const label = select.closest(
        '.product-form__option'
      )?.querySelector('.product-form__selected-value');

      if (label) {
        label.textContent = matchingOption.textContent.trim();
      }
    });
  }

  // Capture a customer's deliberate selection.
  document.addEventListener('change', function (event) {
    const select = event.target;

    if (
      !(select instanceof HTMLSelectElement) ||
      !select.matches(
        'select[data-required-selection="true"]'
      )
    ) {
      return;
    }

    rememberSelection(select);
  }, true);

  // Warehouse replaces product content after
  // certain variant changes.
  document.addEventListener('product:rerender', function (event) {
    const formId = event.detail?.formId ||
      event.target?.id;

    // Allow Warehouse to finish its DOM replacement.
    requestAnimationFrame(function () {
      document.querySelectorAll('variant-picker').forEach(
        function (picker) {
          if (!formId || getKey(picker) === formId) {
            restoreSelections(picker);
          }
        }
      );
    });
  });

  // Also handle variant changes and their DOM updates.
  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(function () {
      document.querySelectorAll('variant-picker').forEach(
        restoreSelections
      );
    });
  });

})();



/**
 * NACC - Mandatory vehicle / size validation
 * Warehouse 7.0.1
 *
 * Intercepts buy-button clicks before Warehouse
 * submits its AJAX Add to Cart request.
 */
(function () {
  'use strict';

  function validateSelection(button) {
    const form = button.closest('form') ||
      button.closest('.product-form')?.querySelector(
        'form[action*="/cart/add"]'
      );

    if (!form) return false;

    const productSection = button.closest(
     '[data-section-type="product"], [data-section-type="product-quick-view"]'
    );

    if (!productSection) {
     return false;
    }

    const requiredSelects = productSection.querySelectorAll(
        'select[data-required-selection="true"]'
    );

  

    for (const select of requiredSelects) {
      if (select.value) {
        select.setCustomValidity('');
        continue;
      }

      const message = select.dataset.selectionType === 'size'
        ? 'Please select your size before adding to cart.'
        : 'Please select your vehicle year/model before adding to cart.';

      // Clear any previous native validation message.
      select.setCustomValidity('');

      // Find or create the inline warning.
      let selectionError = select.parentElement.querySelector(
        '.nacc-selection-error'
      );

      if (!selectionError) {
        selectionError = document.createElement('p');
        selectionError.className = 'nacc-selection-error';
        selectionError.setAttribute('role', 'alert');

        selectionError.style.cssText = `
          color: #c62828;
          font-size: 14px;
          font-weight: 500;
          margin: 10px 0 0;
        `;

        select.insertAdjacentElement('afterend', selectionError);
      }

      selectionError.textContent = message;

      // Direct the customer to the missing selection.
      select.focus();

      return false;
    }

        // Require deliberate colour selection where enabled.
    const colorGroup = productSection.querySelector(
      '[data-require-color-confirmation="true"]'
    );

    if (colorGroup && colorGroup.dataset.colorConfirmed !== 'true') {
      const colorRadio = colorGroup.querySelector(
        'input.color-swatch__radio:checked'
      );

          let colorError = colorGroup.parentElement.querySelector(
        '.nacc-color-error'
      );

      if (!colorError) {
        colorError = document.createElement('p');
        colorError.className = 'nacc-color-error';
        colorError.setAttribute('role', 'alert');
        colorError.textContent =
          'Please select your colour before adding to cart.';

        colorError.style.cssText = `
          color: #c62828;
          font-size: 14px;
          font-weight: 500;
          margin: 10px 0 0;
        `;

        colorGroup.insertAdjacentElement('afterend', colorError);
      }
     

      colorGroup.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return false;
    }
    return true;
  }

    document.addEventListener('change', function (event) {
      const select = event.target;

      if (!select.matches(
        'select[data-required-selection="true"]'
      )) {
        return;
      }

      select.setCustomValidity('');

      // Remove the warning once a valid selection is made.
      if (select.value) {
        const selectionError = select.parentElement.querySelector(
          '.nacc-selection-error'
        );

        if (selectionError) {
          selectionError.remove();
        }
      }
    }, true);

  // Capture clicks before Warehouse's buy-button handler.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('buy-button');

    if (!button) return;

    if (!validateSelection(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

})();
/**
 * NACC - Mandatory colour swatch confirmation
 * Warehouse 7.0.1
 *
 * Track deliberate customer colour choices.
 * Preserve confirmation when Warehouse rerenders
 * the variant picker.
 */
(function () {
  'use strict';

  const confirmedColors = new Map();

  function getColorGroup(picker) {
    return picker.querySelector(
      '[data-require-color-confirmation="true"]'
    );
  }

  function updateConfirmation(picker) {
    const group = getColorGroup(picker);
    if (!group) return;

    const key = picker.getAttribute('form-id');
    if (!key) return;

    const confirmed = confirmedColors.get(key);

    const selectedRadio = group.querySelector(
      'input.color-swatch__radio:checked'
    );

    const isConfirmed = Boolean(
      confirmed &&
      selectedRadio &&
      confirmed === selectedRadio.value
    );

    group.dataset.colorConfirmed = String(isConfirmed);
  }

  // Record actual customer interaction with a swatch.
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest(
      '.color-swatch__item'
    );

    if (!swatch) return;

    const group = swatch.closest(
      '[data-require-color-confirmation="true"]'
    );

    if (!group) return;

    const picker = group.closest('variant-picker');
    if (!picker) return;

    const key = picker.getAttribute('form-id');
    if (!key) return;

    const radio = group.querySelector(
      'input.color-swatch__radio[id="' +
      CSS.escape(swatch.getAttribute('for') || '') +
      '"]'
    );

    if (!radio || radio.disabled) return;

    confirmedColors.set(key, radio.value);

    group.dataset.colorConfirmed = 'true';

          // Remove the colour warning once the customer selects a colour.
      const colorError = group.parentElement.querySelector(
        '.nacc-color-error'
      );

      if (colorError) {
        colorError.remove();
      }

  }, true);

  // Recheck confirmation after variant changes.
  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(function () {
      document.querySelectorAll('variant-picker').forEach(
        updateConfirmation
      );
    });
  });

  // Recheck confirmation after product rerenders.
  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(function () {
      document.querySelectorAll('variant-picker').forEach(
        updateConfirmation
      );
    });
  });

})();
/**
 * NACC - Show colour swatches as unselected
 * until the customer confirms a colour.
 */
(function () {
  const style = document.createElement('style');

  style.textContent = `
    .color-swatch-list[data-require-color-confirmation="true"]
    [data-color-confirmed="false"] {
      outline: none;
    }

    .color-swatch-list[data-require-color-confirmation="true"][data-color-confirmed="false"]
    .color-swatch__radio:checked + .color-swatch__item::after {
      opacity: 0 !important;
    }
  `;

  document.head.appendChild(style);
})();